module.exports = __webpack_public_path__ + "img/shield-bios-banner-02-square.b429eb64.jpg";